import React, { useContext, createContext, useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import Functions from "../../../utility/services/Functions";
import { AuthContext } from "../../../utility/services/AuthContext";

const ReactIdleContext = createContext(null);
const { Provider } = ReactIdleContext;

const ReactIdleProvider = ({ children, isUserLoggedIn }) => {
  const { logOut, consoleService } = Functions();
  const { setSessionModalShow } = useContext(AuthContext);
  const minutes = 60;

  const onIdle = () => {
    if (isUserLoggedIn) {
      logOut();
      setSessionModalShow(true);
      consoleService("session out");
    }
  };

  const { start, pause } = useIdleTimer({
    onIdle,
    timeout: minutes * (60 * 1000),
    startManually: true,
  });

  useEffect(() => {
    if (isUserLoggedIn) {
      start();
    } else {
      pause();
    }
  }, [isUserLoggedIn]);

  return <Provider value={{ pause, start }}>{children}</Provider>;
};

export { ReactIdleProvider, ReactIdleContext };
